export const hasProfileFormChanged = (originalUserInfo, currentForm) => {
  if (!originalUserInfo) return false;

  const originalForm = {
    firstName: originalUserInfo.firstName || "",
    lastName: originalUserInfo.lastName || "",
    email: originalUserInfo.email || "",
    company: originalUserInfo.info?.company || "",
    industry: originalUserInfo.info?.industry || "",
    howLongCompany: originalUserInfo.info?.howLongCompany || "",
    functionCompany: originalUserInfo.info?.functionCompany || [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
    ],
    managementPosition: originalUserInfo.info?.managementPosition || "",
    titleCompany: originalUserInfo.info?.titleCompany || "",
    directors: originalUserInfo.info?.directors || "",
    yearRange: originalUserInfo.info?.yearRange || "",
    gender: originalUserInfo.info?.gender || "",
  };

  // Compare simple string fields
  const simpleFields = [
    "firstName",
    "lastName",
    "email",
    "company",
    "industry",
    "howLongCompany",
    "managementPosition",
    "titleCompany",
    "directors",
    "yearRange",
    "gender",
  ];

  for (const field of simpleFields) {
    if (originalForm[field] !== currentForm[field]) {
      return true;
    }
  }

  const originalFunctions = originalForm.functionCompany;
  const currentFunctions = currentForm.functionCompany;

  if (originalFunctions.length !== currentFunctions.length) {
    return true;
  }

  for (let i = 0; i < originalFunctions.length; i++) {
    if (originalFunctions[i] !== currentFunctions[i]) {
      return true;
    }
  }

  return false;
};
